<template>
  <div class="container_box">
    <Tabs v-model="pageParams.supplierStatus" :animated="false" class="tabs_styles" @on-click="search()">
      <TabPane v-for="item in supplierStatusList" :label="(h)=>labelRander(h, item)" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '100px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002819')">
              <Date-picker
                type="datetimerange"
                class="filter_time_box"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="registerTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002820')" prop="searchValue">
              <Input :placeholder="$t('key1002821')" v-model.trim="pageParams.searchValue"></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search" :disabled="tableLoading">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button type="primary" @click="$refs['addSupplier'].initSupplierData('add')"
        v-if="getPermission('ymsSupplierMerchant_create')">{{ $t('key1002822') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="tableDom"
        highlight-row
        border
        max-height="490"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-sort-change="sortChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--新增供应商弹窗-->
    <addSupplierModal ref="addSupplier" @updateData="search()"></addSupplierModal>
    <!--停用供应商弹窗-->
    <deactivateModal ref="deactivate" @deactivateBtn="deactivateBtn"></deactivateModal>
    <!--供应商日志弹窗-->
    <commonLogModal ref="commonLog" logMode="YMS_STANDARD" :showWarehouse="true" :logType="['SUPPLIER_LOG', 'SYSTEM_LOG']"></commonLogModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import addSupplierModal from "@/views/yms/components/supplierManagement/addSupplierModal";
import dropDownFilter from "@/components/common/dropDownFilter";
import deactivateModal from "@/views/yms/components/supplierManagement/deactivateModal.vue";
import commonLogModal from "@/components/common/commonLogModal";

export default {
  name: 'supplierManagement',
  mixins: [Mixin],
  components: {
    addSupplierModal,
    dropDownFilter,
    deactivateModal,
    commonLogModal
  },
  data() {
    return {
      registerTime: [],
      total: 0,
      pageParams: {
        supplierAuditStatus: 2, // 供应商审核状态 0审核不通过、1待审核、2审核通过
        supplierStatus: '1',
        createdStartTime: null,
        createdEndTime: null,
        ymsMerchantIds: '', // 供应商编号
        mobiles: '', // 手机号
        emails: '', // 邮箱
        searchValue: '',
        upDown: 'down',
        orderBy: 'createdTime',
        pageNum: 1,
        pageSize: 15
      },
      tableColumns: [],
      pageParamsStatus: false,
      tableData: [],
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002805'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002806'), parameterKey: 'ymsMerchantIds'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002339'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002807'), parameterKey: 'mobiles'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002808'), parameterKey: 'emails'}
      ],
      defaultSelectValue: 1,
      labelRander: (h, params) => {
        let total = params.total || 0;
        return h('div', {class: 'flex align-items-center'}, [
          h('span', params.title),
          total > 0 ? h('span', `(${total})`) : '',
        ]);
      },
      supplierStatusList: [
        {value: '1', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002809'), total: 0},
        {value: '0', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002810'), total: 0}
      ],
      ymsMerchantId: null
    };
  },
  computed: {
    filterKeyList() {
      return this.dropDownInputList.map((item) => {
        return item.parameterKey;
      });
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        await v.systemDefaultLanguage();
        v.handleColumns();
        v.search();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.registerTime = [];
      v.changeInput(1);
      v.resetDate();
      v.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.supplierStatus = Number(v.pageParams.supplierStatus);
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      return params;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.optionBtnWidth = [];
      /*v.getSupplierAuditStatusTotal();*/
      if (v.getPermission('ymsSupplierMerchant_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsSupplierMerchant_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            let newList = data.list || [];
            v.total = data.total;
            if (newList.length > 0) {
              newList.map((item) => {
                let obj = v.handleMultilingualFormFields(item, ['name']);
                let newItem = Object.assign({}, item, obj) || item;
                v.tableData.push(newItem);
              });
              v.updateTableDom('tableDom');
            } else {
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 重置创建时间
    resetDate() {
      this.pageParams.createdStartTime = null;
      this.pageParams.createdEndTime = null;
    },
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.createdStartTime = null;
          v.pageParams.createdEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.registerTime = v.defaultTimePeriod(value, false);
          v.pageParams.createdStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.createdEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 启用、停用按钮
    enableDisableBtn(type, ymsMerchantId, supplierDisableRemarks) {
      let v = this;
      let url = '';
      let text = '';
      let query = {
        supplierDisableRemarks: null,
        ymsMerchantId: ymsMerchantId
      };
      // 启用
      if (type === 'enable') {
        url = api.post_ymsSupplierMerchant_enable;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002473');
      }
      // 停用
      else {
        query.supplierDisableRemarks = supplierDisableRemarks;
        url = api.post_ymsSupplierMerchant_disable;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002472');
      }
      v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(text);
          v.$refs['deactivate'].deactivateModal = false;
          v.getList();
        }
      });
    },
    // 停用供应商
    deactivateBtn(val) {
      this.enableDisableBtn('disable', this.ymsMerchantId, val);
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 获取供应商在不同的状态下的总数
    getSupplierAuditStatusTotal() {
      let v = this;
      v.axios.get(api.get_ymsSupplierMerchant_queryTotalBySupplierAuditStatus).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            v.supplierStatusList.map((ele) => {
              let val = Number(ele.value);
              ele.total = 0;
              data.map((item) => {
                if (item.supplierStatus == val) {
                  ele.total = item.number;
                }
              });
            });
            v.$forceUpdate();
          }
        }
      });
    },
    // 处理列表Columns字段
    handleColumns() {
      let v = this;
      v.tableColumns = [];
      let columns = [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002805'),
          key: 'ymsMerchantId',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101'),
          key: 'name',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000733'),
          key: 'currency',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let currency = params.row.currency || 'CNY';
            return h('span', currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002811'),
          key: 'contacts',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002812'),
          key: 'mobile',
          align: 'center',
          minWidth: 140
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002813'),
          key: 'phone',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'),
          key: 'email',
          align: 'center',
          minWidth: 170
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002751'),
          key: 'businessLicensePath',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            return v.tableImg(h, params, 'businessLicensePath',
              null, null, 'left', false, false);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002814'),
          key: 'totalSkuNumber',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let number = params.row.totalSkuNumber || 0;
            return h('span', number);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002815'),
          key: 'createdTime',
          align: 'center',
          width: 180,
          sortable: 'custom',
          sortType: 'desc',
          render(h, params) {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002816'),
          key: 'supplierDisableTime',
          align: 'center',
          width: 180,
          sortable: 'custom',
          render(h, params) {
            let supplierDisableTime = params.row.supplierDisableTime;
            return h('span', v.$uDate.dealTime(supplierDisableTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 200,
          align: 'center',
          fixed: 'right',
          render(h, params) {
            let ymsMerchantId = params.row.ymsMerchantId;
            let supplierStatus = params.row.supplierStatus;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      v.$refs['addSupplier'].initSupplierData('look', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: supplierStatus === 0 && v.getPermission('ymsSupplierMerchant_enable'),
                    clickFn: () => {
                      v.$Modal.confirm({
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001984'),
                        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002817'),
                        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002483'),
                        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
                        onOk: () => {
                          v.enableDisableBtn('enable', ymsMerchantId);
                        },
                        onCancel: () => {
                        }
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    color: '#FF0000',
                    show: supplierStatus === 1 && v.getPermission('ymsSupplierMerchant_disable'),
                    clickFn: () => {
                      v.ymsMerchantId = ymsMerchantId;
                      v.$refs['deactivate'].deactivateModal = true;
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsSupplierMerchant_update'),
                    clickFn: () => {
                      v.$refs['addSupplier'].initSupplierData('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(ymsMerchantId);
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      let list = [];
      if (v.multilingualNamesList.length > 0) {
        v.multilingualNamesList.map((item) => {
          let key = 'name_' + item.code;
          list.push({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000295') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002818'),
            key: key,
            align: 'center',
            minWidth: 150
          });
        });
      }
      if (list.length > 0) {
        columns.splice(1, 1, ...list);
        v.tableColumns = columns;
      }
      v.$forceUpdate();
    },
    // 时间排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      this.pageParams.orderBy = data.key;
      this.pageParamsStatus = true;
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
